module.exports = __webpack_public_path__ + "media/images/keep_delete-fa38ede91fbf82dc2fb9b32eba471ee0.svg";